import { FormStepId } from 'shared/config/formStepId';

import { AccordionModalForm as AccordionModalFormAdditionalInfo } from 'features/UpdateAdditionalInfo';
import { AccordionModalForm as AccordionModalFormContactsInfo } from 'features/UpdateContactsInfo';
import { AccordionModalForm as AccordionModalFormCreditPurposeInfo } from 'features/UpdateCreditPurposeInfo';
import { AccordionModalForm as AccordionModalFormPassportInfo } from 'features/UpdatePassportInfo';
import { AccordionModalForm as AccordionModalFormWorkplaceInfo } from 'features/UpdateWorkplaceInfo';

type TWidgetBlockProps = TAccordionProps & {
  multipartFormId: string;
  isSummary?: boolean;
  shouldRestoreAdditionalData?: boolean;
  isHideAccordionData?: boolean;
};

export const WIDGET_BLOCKS: Record<FormStepId, { formStepComponent: FC<TWidgetBlockProps>; submitButtonText: string }> =
  {
    [FormStepId.CreditPurposeInfo]: {
      formStepComponent: AccordionModalFormCreditPurposeInfo,
      submitButtonText: 'Далее',
    },
    [FormStepId.ContactsInfo]: {
      formStepComponent: AccordionModalFormContactsInfo,
      submitButtonText: 'Далее',
    },
    [FormStepId.PassportInfo]: {
      formStepComponent: AccordionModalFormPassportInfo,
      submitButtonText: 'Далее',
    },
    [FormStepId.WorkplaceInfo]: {
      formStepComponent: AccordionModalFormWorkplaceInfo,
      submitButtonText: 'Далее',
    },
    [FormStepId.AdditionalInfo]: {
      formStepComponent: AccordionModalFormAdditionalInfo,
      submitButtonText: 'Показать предложения',
    },
  };
